export const GET_BILLS_REQUEST = "GET_BILLS_REQUEST";
export const GET_BILLS_SUCCESS = "GET_BILLS_SUCCESS";
export const GET_BILLS_FAIL = "GET_BILLS_FAIL";

export const CREATE_BILL_REQUEST = "CREATE_BILL_REQUEST";
export const CREATE_BILL_SUCCESS = "CREATE_BILL_SUCCESS";
export const CREATE_BILL_FAIL = "CREATE_BILL_FAIL";

export const UPDATE_BILL_REQUEST = "UPDATE_BILL_REQUEST";
export const UPDATE_BILL_SUCCESS = "UPDATE_BILL_SUCCESS";
export const UPDATE_BILL_FAIL = "UPDATE_BILL_FAIL";

export const DELETE_BILL_REQUEST = "DELETE_BILL_REQUEST";
export const DELETE_BILL_SUCCESS = "DELETE_BILL_SUCCESS";
export const DELETE_BILL_FAIL = "DELETE_BILL_FAIL";